import { Button } from 'antd';
import type { ProposalState } from '../trip-accessorials.api';

interface DecisionButtonsProps {
  state: ProposalState;
  onConfirm: () => void;
  onAdjust: () => void;
  onDrop: () => void;
}

/** Only the answers that would change something: a confirmed proposal has no Confirm, a dropped one no Drop. */
export function DecisionButtons({ state, onConfirm, onAdjust, onDrop }: DecisionButtonsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {state !== 'confirmed' && (
        <Button type="primary" onClick={onConfirm}>
          Confirm
        </Button>
      )}
      <Button onClick={onAdjust}>Adjust</Button>
      {state !== 'dropped' && (
        <Button danger onClick={onDrop}>
          Drop
        </Button>
      )}
    </div>
  );
}
